import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { ConfigTurnsService } from 'src/app/services/turns-services/config-turns-service/config-turns.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';

@Component({
  selector: 'app-turns-config-dashboard',
  templateUrl: './turns-config-dashboard.component.html',
  styleUrls: ['./turns-config-dashboard.component.scss']
})
export class TurnsConfigDashboardComponent implements OnInit, OnDestroy {

  config;
  listenGetTurnsConfigSubscription: Subscription;
  getTurnsConfigSubscription: Subscription;

  constructor(private configTurns: ConfigTurnsService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.getTurnsConfig();
    this.listenGetTurnsConfig();
    this.setBreadcrumb();
  }

  private listenGetTurnsConfig() {
    this.listenGetTurnsConfigSubscription = this.configTurns.listenRefreshTurnsConfigListener().pipe(
      tap(o => this.getTurnsConfig())
    ).subscribe();
  }

  private getTurnsConfig() {
    this.getTurnsConfigSubscription = this.configTurns.getTurnsConfig().pipe(
      tap(o => this.config = o)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-cogs', 'turns-page.config', '/turns', [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.config')]));
  }

  ngOnDestroy() {
    if (this.listenGetTurnsConfigSubscription) { this.listenGetTurnsConfigSubscription.unsubscribe(); }
    if (this.getTurnsConfigSubscription) { this.getTurnsConfigSubscription.unsubscribe(); }
  }

}
